// extracted by mini-css-extract-plugin
export default {"error":"DashboardSectionError_error__16tO5"};